import { useMemo } from "react";

import useLocalizedOptionsConfiguration from "./useLocalizedOptionsConfiguration";

export default function useNormalizedSkillOptions() {
  const skillOptionsConfiguration =
    useLocalizedOptionsConfiguration().skillQuestionOptionsConfiguration;

  const normalizedOptions = useMemo(() => {
    const normalizedConfiguration = skillOptionsConfiguration.map(
      ({ value, ...rest }) => ({
        ...rest,
        value:
          skillOptionsConfiguration.length > 1
            ? (1 / (skillOptionsConfiguration.length - 1)) * parseInt(value)
            : 1,
      })
    );

    return normalizedConfiguration;
  }, [skillOptionsConfiguration]);

  return normalizedOptions;
}
